// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as FareType from "../entity/FareType.bs.js";
import * as CrmNetwork from "../../../../../library/network/CrmNetwork.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as AdjustFareRepoConfig from "./AdjustFareRepoConfig.bs.js";
import * as PreviewAndUpdateFarePayload from "../entity/PreviewAndUpdateFarePayload.bs.js";

function fetchFare(crn, fareType, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/support/order/" + crn + "/fare?type=" + FareType.toString(fareType);
  return CrmNetwork.get(requestUrl, "/support/order/:crn/fare", {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AdjustFareRepoConfig.AdjustFareResponseConverter.execute, result);
                        });
            });
}

function previewFareChanges(payload, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/support/order/" + payload.crn + "/fare?commit=false";
  var encodedPayload = JSON.stringify(PreviewAndUpdateFarePayload.t_encode(payload));
  return CrmNetwork.postRequestV2(requestUrl, "/support/order/:crn/fare", encodedPayload, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AdjustFareRepoConfig.PreviewAdjustFareResponseConverter.execute, result);
                        });
            });
}

function updateFare(payload, country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/support/order/" + payload.crn + "/fare?commit=true";
  var encodedPayload = JSON.stringify(PreviewAndUpdateFarePayload.t_encode(payload));
  return CrmNetwork.postRequestV2(requestUrl, "/support/order/:crn/fare", encodedPayload, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AdjustFareRepoConfig.UpdateAdjustFareResponseConverter.execute, result);
                        });
            });
}

function getIncidentalChargeTypes(country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/support/incidental_charge_types";
  return CrmNetwork.get(requestUrl, undefined, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AdjustFareRepoConfig.IncidentalChargeTypeResponseConverter.execute, result);
                        });
            });
}

var AdjustFareRepo = {
  fetchFare: fetchFare,
  previewFareChanges: previewFareChanges,
  updateFare: updateFare,
  getIncidentalChargeTypes: getIncidentalChargeTypes
};

export {
  AdjustFareRepo ,
  
}
/* Config Not a pure module */
